import React, { useState } from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Button } from "../../components/Button";
// import { ConsultModal } from "../../components/ConsultModal";
import { ConsultFormModal } from "../../components/CommonFormModal";

export const SolutionWechatBanner = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  return (
    <section>
      <div className="solution-wechat-banner-warp">
        <div className="solution-wechat-banner">
          <div className="banner-img">
            <img
              src="//files.authing.co/authing-website/solution-wechat-banner.png"
              alt="authing wechat banner"
            />
          </div>
          <div className="wechat-banner-content">
            <div className="wechat-banner-title">
              {t("solution.wechat.banner.title")}
            </div>
            <div className="wechat-banner-subtitle">
              {t("solution.wechat.banner.subtitle")}
            </div>
            <Button
              onClick={() => setVisible(true)}
              className="ask-solution-btn"
            >
              {t("solution.detail.button-consult")}
            </Button>
          </div>
        </div>
      </div>
      {/* <ConsultModal {...{ visible, setVisible }} /> */}
      <ConsultFormModal {...{ visible, setVisible }} />
    </section>
  );
};
